import { invalidateAllQueries } from "bonzai"
import { useSharedDeviceStore } from "../components/SharedDeviceInactivityTracker"
import { getCompanyCached } from "../graphql/getCompanyCached"
import { changeLocale } from "../i18n/changeLocale"
import { sendVuplexMessage } from "../vuplex/sendVuplexMessage"
import { subscribeToVuplex } from "../vuplex/subscribeToVuplex"
import { useVuplexStore } from "../vuplex/vuplexStore"

export const initializeVuplex = async () => {
  subscribeToVuplex("REFRESH_PRODUCT_SCORE", () => {
    // Native app's product-score refresh path (ActionCable has been removed).
    invalidateAllQueries()
  })

  subscribeToVuplex("SET_PUSH_NOTIFICATIONS_ENABLED", (message) => {
    useVuplexStore.setState({
      pushNotificationsEnabled: message.payload,
    })
  })

  subscribeToVuplex("SET_IS_SHARED_DEVICE", (message) => {
    useSharedDeviceStore.setState({
      isSharedDevice: message.payload,
    })
  })

  subscribeToVuplex("SET_LANGUAGE", async (event) => {
    const currentCompany = await getCompanyCached()
    const { portalSupportedLocales } = currentCompany

    const locale = event.payload.localeCode
    const isValid = portalSupportedLocales.includes(locale)
    if (isValid) changeLocale(locale)
  })

  sendVuplexMessage({ type: "READY" })
}
